import { render, staticRenderFns } from "./newAnkang.vue?vue&type=template&id=631bfe04&scoped=true&"
import script from "./newAnkang.vue?vue&type=script&lang=js&"
export * from "./newAnkang.vue?vue&type=script&lang=js&"
import style0 from "./newAnkang.vue?vue&type=style&index=0&id=631bfe04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631bfe04",
  null
  
)

export default component.exports